export const GenderType = Object.freeze({
  Male: true,
  Female: false,
});
